import PhotoWrapper from "../homepage/agent/photo-wrapper";
import PropTypes from "prop-types";
import React from "react";
import ReadMore from "../shared/read-more/";

const BioImage = ({ entity }) => {
  let classes = "";
  if (!entity.hasPhoto) {
    classes += "no-image ";
  }
  if (!entity.bcVideoRefId) {
    classes += "no-video";
  }
  return (
    <div className={classes}>
      <PhotoWrapper entity={entity} customClasses="photo" />
      <div
        className={
          "biography " +
          (entity.bcVideoRefId || !entity.hasPhoto
            ? "col-xs-16"
            : "col-sm-8 col-xs-16")
        }
      >
        <div className="visible-xxs hidden">
          <ReadMore>
            <p dangerouslySetInnerHTML={{ __html: entity.biography }}></p>
          </ReadMore>
        </div>
        <div className="hidden-xxs">
          <p dangerouslySetInnerHTML={{ __html: entity.biography }}></p>
        </div>
      </div>
    </div>
  );
};

BioImage.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default BioImage;



// WEBPACK FOOTER //
// ./src/components/about/bio-image.js